/* eslint-disable react-hooks/exhaustive-deps */
import useShowDialogAlert from "components/DialogAlert/utils/hooks/useDialogAlert";
import { useEffect, useRef, useState } from "react";
import { wait } from "utils/others";

const useUpdateActivityPopup = ({
	$activity, isPast = false
}) => {
	const $popup = useRef();
	const [backgroundClassList, setBackgroundClassList] = useState([]);
	const [popupClassList, setPopupClassList] = useState([]);
	const popup = useShowDialogAlert(toggle => {
        if (isPast) return;
		if (popup.value) {
			closePopup();
            return;
        }
        toggle();
        enableTableScroll(false);
    });
	useEffect(() => {
		if (popup.value)
            adjustPopupPosition();
		toggleScrollBodyByPopupState();
    }, [popup.value]);
    function enableTableScroll(enableScroll) {
        if (!$activity.current) return;
        const $tableWrapper = $activity.current.closest(".custom-scrollbar");
        $tableWrapper.classList[enableScroll ? "remove" : "add"]("no-scroll");
    }
    function openPopup() {
        popup.open();
        enableTableScroll(false);
    }
	async function closePopup() {
		setBackgroundClassList(["hidden"]);
		setPopupClassList(prev => [...prev, "hidden"]);
        await wait(200);
        enableTableScroll(true);
        await wait(150);
        popup.hide();
    }
	function adjustPopupPosition() {
		setBackgroundClassList([]);
		setPopupClassList(getPopupClassList());
	}
	function toggleScrollBodyByPopupState() {
        document.body.classList[popup.value ? "add" : "remove"]("no-scroll");
	}
	function getPopupClassList() {
        // Verificando si está abierto y la referencia de activityCardE existe
        if (!$activity.current || !$popup.current) return [];
        let classList = [];
        //#region Declaraciones de referencias
        // Obteniendo referencias para la corrección de movimiento
        const popupRect = $popup.current.getBoundingClientRect();
        const activityCardRect = $activity.current.getBoundingClientRect();
        //#endregion
        const position = {
            x: 0,
            y: 0
        };
        //#region Ajustando x
        position.x = activityCardRect.x - popupRect.width*1.035;
        classList.push("top");
        // Verificando si el cuadro de diálogo ha tocado el límite izquierdo para pasarlo a la derecha del card de actividad
        if (position.x < 0) {
            position.x += popupRect.width*1.035 + activityCardRect.width*1.07;
            classList.push("right");
        }
        //#endregion
        //#region Ajustando y
        position.y = activityCardRect.y;
        // Verificando si el cuadro de diálogo ha tocado el límite inferior para pasarlo al medio del card de actividad
        if (position.y + popupRect.height >= window.innerHeight) {
            position.y -= popupRect.height/2 - activityCardRect.height/2;
            classList.push("middle");
        }
        // Verificando si el cuadro de diálogo ha tocado el límite inferior estando al medio del card de actividad para pasarlo al arriba
        else if (position.y + popupRect.height >= window.innerHeight) {
            position.y -= popupRect.height/2 - activityCardRect.height/2;
            classList.push("bottom");
        }
        if (position.y + popupRect.height >= window.innerHeight) {
            position.y -= popupRect.height/2 - activityCardRect.height/2;
            classList = classList.filter(className => !["middle", "top"].includes(className));
            classList.push("bottom");
        }
        //#endregion
        $popup.current.style.left = `${position.x}px`;
        $popup.current.style.top = `${position.y}px`;
        return classList;
    }
	return {
		classListGroup: {
			background: backgroundClassList,
			popup: popupClassList
		}, 
		popup: {
			...popup,
            open: openPopup,
			hide: closePopup
		},
		$popup,
		adjustPopupPosition
	};
}

export default useUpdateActivityPopup;